import {LOADING, LOADED_ME, AUTH_CODE_ISSUED} from './actions'

export const me = (state = null, action) => {
    switch (action.type) {
        case LOADED_ME:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};

export const loading = (state = {active: false, loading_content: null}, action) => {
    switch (action.type) {
        case LOADING:
            return {
                active: action.payload,
                loading_content: action.content,
            }
        default:
            return state;
    }
};

export const AuthCodeReducer = (state = false, action) => {
    switch (action.type) {
        case AUTH_CODE_ISSUED:
            return action.payload;
        default:
            return state;
    }
};
